import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import { useInputForm } from 'components/dataCreationForms/withInputForm';
import { CollapsibleCommentShell } from 'components/inspection/CollapsibleCommentShell';
import {
  INSPECTION_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA,
  INSPECTION_COMMENT_LABEL_QA,
  isCommentLocked,
  isFloatingCommentLabel,
  resolveCommentValue,
} from './model';
import {
  InspectionCommentLabelVariant,
  type CollapsibleInspectionCommentProps,
} from './types';

export { InspectionCommentLabelVariant } from './types';

export function CollapsibleInspectionComment({
  formKey,
  fallbackValue = '',
  disabled,
  labelVariant = InspectionCommentLabelVariant.floating,
  focusSignal = 0,
  children,
}: CollapsibleInspectionCommentProps): ReactElement {
  const intl = useIntl();
  const { values } = useInputForm();
  const locked = isCommentLocked(disabled);
  const currentValue = resolveCommentValue(values[formKey], fallbackValue);
  const label = formatTranslation(intl, InspectionTranslationKeys.comment);

  return (
    <CollapsibleCommentShell
      value={currentValue}
      label={label}
      locked={locked}
      showFloatingLabel={isFloatingCommentLabel(labelVariant)}
      focusSignal={focusSignal}
      toggleDataQa={INSPECTION_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA}
      labelDataQa={INSPECTION_COMMENT_LABEL_QA}
    >
      {children}
    </CollapsibleCommentShell>
  );
}
